import { ThemeIcon, ThemeIconProps } from "@mantine/core";
import { IColor, variantColors } from "../../utils/selectColors";

interface IProps extends ThemeIconProps {
  children: React.ReactNode;
  colorIcon?: IColor;
}

const IconColor: React.FC<IProps> = ({ children, colorIcon, ...props }) => {
  const colorSelected: IColor = !!colorIcon ? colorIcon : IColor.green;
  const selectedVariant = variantColors[colorSelected];

  return (
    <ThemeIcon
      variant="light"
      size={48}
      p={8}
      style={{
        border: "unset",
        borderRadius: "8px",
        fontSize: "28px",
        background: selectedVariant.bg,
        color: selectedVariant.color,
      }}
      {...props}
    >
      {children}
    </ThemeIcon>
  );
};

export default IconColor;
